<template>
  <div>
    <div v-if="!isUpload">
      <!--   <v-card flat :loading="loadLaudo" v-if="status != 'L'"> -->
      <v-card flat :loading="loadLaudo">
        <v-toolbar flat dense class="px-0" color="transparent">
          <v-btn color="red" text @click="voltar()" class="ml-0">
            <v-icon left color="red">mdi-keyboard-return</v-icon>
            <span class="hidden-sm-and-down">VOLTAR</span>
          </v-btn>

          <v-spacer></v-spacer>

            <!-- Campo de data -->
            <!-- <v-col cols="12" sm="5" md="4" lg="3" class="pr-2">
              <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="computedDateFormatted" label="Data" dense outlined persistent-hint
                    prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details></v-text-field>
                </template>
                <v-date-picker v-model="date" no-title @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col> -->

            <!-- Autocomplete de modelos -->
            <v-col cols="12" sm="6" md="5" lg="4" class="pr-2">
              <v-autocomplete v-model="modelo" :items="modeloLaudo.modelos" :loading="isLoading" dense outlined
                hide-no-data hide-selected item-text="nome" item-value="_id" label="Buscar Modelos"
                placeholder="Digite para buscar" prepend-icon="mdi-database-search" return-object
                hide-details></v-autocomplete>
            </v-col>

            <!-- Botões de ação -->
            <v-col cols="auto" class="d-flex">
              <v-btn color="red accent-1" icon small @click="clear">
                <v-icon>mdi-broom</v-icon>
              </v-btn>

              <v-btn :disabled="content.length < 8" v-if="idMedelo == null" icon small color="blue darken-1"
                @click="dialogNovoModelo = true">
                <v-icon>mdi-note-plus</v-icon>
              </v-btn>

              <v-btn v-else icon small :disabled="content.length < 8" color="teal darken-2"
                @click="dialogEditarModelo = true">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </v-col>

        </v-toolbar>

        <v-sheet min-height="60vh" rounded="lg">
          <v-card flat class="overflow-auto" height="560px">
            <tiptap-vuetify v-show="!isImprime" v-model="content" :card-props="{ flat: true }" :extensions="extensions"
              placeholder="Descrição …" />
          </v-card>
        </v-sheet>
        <v-divider />
        <v-card-actions>
          <v-btn :loading="loadSave" disabled color="primary"><v-icon left>mdi-pencil</v-icon> assinar
            digitalmente</v-btn>
          <v-btn disabled text color="blue" @click="isUpload = true"><v-icon large
              left>drive_folder_upload</v-icon>anexos</v-btn>
          <v-spacer />
          <v-switch color="green" v-model="status" label="LIBERAR" value="LX"></v-switch>
          <v-btn class="ml-2" text readonly :loading="loadSave" :disabled="content.length < 8"
            @click="idLaudo == null ? salvarLaudo() : editarLaudo()" color="blue">
            <v-icon large rigth v-text="idLaudo != null ? 'save_as' : 'save'"></v-icon>
            salvar
          </v-btn>
        </v-card-actions>

        <v-alert dense v-show="alert.visible" :type="alert.type">
          {{ alert.message }}
        </v-alert>
      </v-card>
      <!-- <v-card v-else flat :loading="loadLaudo">
        <v-card-actions>
          <v-btn :disabled="idExamesOs == null && content.length > 7" color="red" text @click="voltar()">
            <v-icon left color="red">keyboard_return</v-icon> VOLTAR
          </v-btn>
        </v-card-actions>
        <v-divider />
        <v-card-text>
          <div v-html="content"></div>
        </v-card-text>
      </v-card> -->

      <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Alerta de liberação
          </v-card-title>

          <v-card-text>
            Atenção: Após a liberação do laudo, não será possível realizar alterações. Certifique-se de revisar todas as
            informações antes de concluir o processo. Deseja prosseguir?
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="dialog = false">
              Voltar
            </v-btn>
            <v-btn color="blue" text @click="idLaudo == null ? salvarLaudo() : editarLaudo()">
              <v-icon left>save</v-icon>
              Continuar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogNovoModelo" width="900">
        <v-card class="rounded-lg">
          <v-card-title class="text-h5 white--text primary py-4">
            <v-icon left color="white">mdi-plus-circle</v-icon>
            Cadastrar novo modelo
          </v-card-title>

          <v-card-text class="pa-6">
            <v-text-field label="Titulo" outlined v-model="tituloModelo"></v-text-field>
            <v-card outlined>
              <tiptap-vuetify v-show="!isImprime" v-model="content" :card-props="{ flat: true }"
                :extensions="extensions" placeholder="Descrição …" />
            </v-card>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn color="red lighten-1" text :loading="loadModelos" @click="dialogNovoModelo = false" class="px-4">
              <v-icon left>mdi-close-circle</v-icon>
              Cancelar
            </v-btn>
            <v-btn color="green darken-1" dark :loading="loadModelos" @click="cadastrarModeloLaudo" class="px-4"
              depressed>
              <v-icon left>mdi-content-save</v-icon>
              Cadastrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogEditarModelo" width="800">
        <v-card class="rounded-lg">
          <v-card-title class="text-h5 white--text teal darken-2 py-4">
            <v-icon left color="white">mdi-pencil-circle</v-icon>
            Editar modelo
          </v-card-title>

          <v-card-text class="pa-6">
            <v-text-field label="titulo" outlined v-model="tituloModelo"></v-text-field>
            <v-card outlined>
              <tiptap-vuetify v-show="!isImprime" v-model="content" :card-props="{ flat: true }"
                :extensions="extensions" placeholder="Descrição …" />
            </v-card>

          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn color="red lighten-1" text @click="dialogEditarModelo = false" class="px-4">
              <v-icon left>mdi-close-circle</v-icon>
              Cancelar
            </v-btn>
            <v-btn color="blue darken-1" dark @click="cadastrarModeloLaudo" class="px-4" depressed>
              <v-icon left>mdi-content-save-edit</v-icon>
              Salvar alterações
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <uploadLaudo @voltar="isUpload = false" v-if="isUpload"
      :ficha="{ idPaciente: paciente.idPaciente, idOrdemServico: paciente.idOrdemServico }" :consulta="consulta">
    </uploadLaudo>
  </div>
</template>

<script>
import medicoService from '../../services/medico.service'
import { EventBus } from '../../main'
import uploadLaudo from '../medico/uploadLaudo.vue'
import 'tiptap-vuetify/dist/main.css'
import {
  TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph,
  BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History
} from 'tiptap-vuetify'
import socketService from '../../services/socket.service'
import { getToken } from '../../store/auth'

export default {
  name: 'Editor',
  components: { TiptapVuetify, uploadLaudo },
  props: {
    paciente: Object,
    consulta: Object,
    userAux: Object
  },
  data: vm => ({
    isImprime: false,
    menu: false,
    loadCadastro: false,
    idLaudo: null,
    loadLaudo: false,
    content: '',
    modelo: null,
    tituloModelo: '',
    loadModelos: false,
    modeloLaudo: {},
    dialogNovoModelo: false,
    dialogEditarModelo: false,
    idMedelo: null,
    isUpload: false,
    dialog: false,
    idExamesOs: null,
    socket: '',
    loadSocket: false,
    menu2: false,
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    dateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
    user: {},
    modelos: [],
    loadSave: false,
    status: 'X',
    alert: { visible: false, message: '', type: '' },
    extensions: [
      History, Blockquote, Link, Underline, Strike, Italic, ListItem, BulletList, OrderedList,
      [Heading, { options: { levels: [1, 2, 3] } }], Bold, Code, HorizontalRule, Paragraph, HardBreak
    ],
    debounceTimeout: null // Adicionado para debounce
  }),
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    }
  },
  mounted () {
    this.user = this.$store.getters.usuario

    // this.listarModelosProntuario()

    // this.socket = io.connect(socketService.SOCKET_URL, {
    //   query: {
    //     token: getToken()
    //   }
    // })
    // this.chamarSocket()
    this.buscarLaudoClinicoPorIdExamesOS()
    this.buscarModeloLaudo()
  },
  methods: {
    clear () {
      this.content = ''
      this.modelo = null
      this.tituloModelo = ''
      this.idMedelo = null
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    buscarLaudoClinicoPorIdExamesOS () {
      console.log('buscarLaudoClinicoPorIdExamesOS', this.consulta)

      const idExameOS = this.consulta.idexamesos ? this.consulta.idexamesos : this.consulta.idExamesOS
      console.log('idExamesOsEncontrado: ', idExameOS)
      medicoService.medico.buscarLaudoClinicoPorIdExamesOS(idExameOS).then(r => {
        console.log(r.data)

        if (r.status == 200) {
          this.idExamesOs = r.data.idExamesOS
          this.content = r.data.descricaoLaudo
          this.status = r.data.status
          this.idLaudo = r.data.id
        }
      }).finally(() => {
        // this.loadLaudo = false
      })
    },
    cadastrarModeloLaudo () {
      this.loadLaudo = true
      const modeloLaudo = {
        idUsuario: this.user.id,
        nome: this.tituloModelo,
        descricao: this.content,
        _id: this.idMedelo
      }
      medicoService.medico.cadastrarModeloLaudo(modeloLaudo).then((r) => {
        if (r.status == 200) {
          this.content = ''
          this.modelo = null
          this.tituloModelo = ''
        }
      }).finally(() => {
        this.loadLaudo = false
        this.dialogNovoModelo = false
        this.dialogEditarModelo = false
        this.idMedelo = null
        this.buscarModeloLaudo()
      })
    },
    buscarModeloLaudo () {
      medicoService.medico.buscarModeloLaudo(this.user.id).then((r) => {
        if (r.status == 200) {
          this.modeloLaudo = r.data
        }
      })
    },
    editarLaudo () {
      this.dialog = false
      this.loadSave = true
      medicoService.medico.editarLaudoClinico(this.idExamesOs, this.content, this.status === 'LX' ? 'L' : 'X').then(r => {
        if (r.status === 200) {
          this.showAlert('Laudo editado com sucesso!', 'info', 3000, () => this.voltar())
        }
      }).finally(() => {
        EventBus.$emit('reloadQuantidadeLaudosTec')
        this.loadSave = false
      })
    },
    chamarSocket () {
      this.socket.on(
        'respostaCadastroTexto',
        function (response) {
          console.log('skt respostaCadastroTexto: ', response, response.message.idExamesOs, this.consulta.idexamesos)
          this.loadSocket = false
          if (response.status === 'success' && response.message.idExamesOs == this.consulta.idexamesos) {
            this.idLaudo = response.message.id
            console.log('entrou: ', this.idLaudo)
          }
        }.bind(this)
      )
      this.socket.on('connect_error', () => {
        this.mensagemNotificacaoSocket = 'aguardando conexao'
      })

      this.socket.on(
        'disconnect',
        function () {
          this.mensagemNotificacaoSocket = 'desconectado'
        }.bind(this)
      )
    },
    salvarLaudo () {
      this.loadSave = true
      this.dialog = false
      const idExameOS = this.consulta.idexamesos ? this.consulta.idexamesos : this.consulta.idExamesOS
      medicoService.medico.cadastrarLaudoClinico({
        idExamesOs: idExameOS,
        idPaciente: this.paciente.idPaciente,
        idEmpresa: this.userAux.idEmpresa,
        idUnidade: this.userAux.idUnidade,
        idPrestador: null,
        idUsuario: this.userAux.id,
        descricao: this.content,
        status: this.status === 'LX' ? 'L' : 'X'
      }).then(r => {
        if (r.status === 200) {
          this.showAlert('Laudo cadastrado com sucesso!', 'success', 3000, () => this.voltar())
        }
      }).finally(() => {
        this.loadSave = false
      })
    },
    showAlert (message, type, timeout = 3000, callback) {
      this.alert = { visible: true, message, type }
      setTimeout(() => {
        this.alert.visible = false
        if (callback) callback()
      }, timeout)
    },
    gerarMensagemComparecimento () {
      const hoje = new Date()
      const dataFormatada = hoje.toLocaleDateString('pt-BR')
      const horaFormatada = hoje.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
      this.content += `${dataFormatada}, às ${horaFormatada}`
    },
    listarModelosProntuario () {
      this.loadModelos = true
      console.log('LAUDO', this.userAux.id, this.consulta.idExame)
      medicoService.medico.listarModelosProntuario('LAUDO', this.userAux.id, this.consulta.idExame).then(({ status, data }) => {
        console.log('Laudo: ', data)
        if (status === 200 && data.status !== 'error') {
          this.modelos = data
        }
      }).finally(() => {
        this.loadModelos = false
      })
    },
    voltar () {
      this.$emit('voltar', true)
    },
    // Função de debounce
    debounce (func, wait) {
      return (...args) => {
        clearTimeout(this.debounceTimeout)
        this.debounceTimeout = setTimeout(() => func.apply(this, args), wait)
      }
    }
  },
  watch: {

    modelo (val) {
      this.tituloModelo = val.nome
      this.idMedelo = val._id
      this.content = val.descricao
    },
    status (val) {
      if (val === 'LX' || val === 'L') {
        val = 'L'
      } else {
        val = 'X'
      }
      /*

      this.socket.emit('escutarEventoTexto', {
        idExamesOS: this.consulta.idexamesos,
        idPaciente: this.paciente.idPaciente,
        idEmpresa: this.userAux.idEmpresa,
        idUnidade: this.userAux.idUnidade,
        idPrestador: null,
        idUsuario: this.userAux.id,
        descricao: this.content,
        idLaudo: this.idLaudo,
        status: val,
        tipo: 'LAUDO'
      })
    },
    content (newContent, oldContent) {
      if (newContent !== oldContent && this.status !== 'L') {
        this.loadSocket = true
        this.debounce(() => {
          this.socket.emit('escutarEventoTexto', {
            idExamesOS: this.consulta.idexamesos,
            idPaciente: this.paciente.idPaciente,
            idEmpresa: this.userAux.idEmpresa,
            idUnidade: this.userAux.idUnidade,
            idPrestador: null,
            idUsuario: this.userAux.id,
            descricao: this.content,
            idLaudo: this.idLaudo,
            status: this.status === 'LX' ? 'L' : 'X',
            tipo: 'LAUDO'
          })
        }, 2000)()
      }
    } */
    }
  }
}
</script>
